import { render, staticRenderFns } from "./VoteCounter.vue?vue&type=template&id=69072682"
import script from "./VoteCounter.vue?vue&type=script&lang=js"
export * from "./VoteCounter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports